import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
    name: 'LinkiFy',
    standalone: false
})

export class TextToLinkPipe implements PipeTransform {
    transform(input: string, aTagClassName = ''): string {
        // Convert Markdown links [name](url) → <a>
        input = input.replace(
            /\[([^\]]+)\]\((https?:\/\/[^\s]+)\)/g,
            (_, text, url) => `<a href="${url}">${text}</a>`
        );

        // Convert plain text URLs → <a>
        input = input.replace(
            /(?<!["'>])(https?:\/\/[^\s<]+)/g,
            (url) => {
                const cleanUrl = url.replace(/[.,;|)]+$/g, '');
                return `<a href="${cleanUrl}">${cleanUrl}</a>`;
            }
        );

        const div = document.createElement('div');
        div.innerHTML = input;

        // Sanitize all <a> tags
        div.querySelectorAll('a').forEach(a => {
            try {
                const href = a.getAttribute('href') || '';

                // Remove unsafe protocols
                const unsafeProtocols = ['javascript:', 'data:', 'vbscript:'];
                if (unsafeProtocols.some(proto => href.toLowerCase().startsWith(proto))) {
                    a.parentNode?.removeChild(a);
                    return;
                }

                // Clean URL
                let cleanUrl = href.trim().replace(/[.,;)|]+$/g, '');
                if (!/^https?:\/\//i.test(cleanUrl)) {
                    cleanUrl = 'https://' + cleanUrl;
                };


                cleanUrl = new URL(cleanUrl).href;
                a.href = cleanUrl;
                a.target = '_blank';
                a.rel = 'noopener';
                if (aTagClassName) {
                    a.className = aTagClassName;
                };
                a.textContent = a.textContent || cleanUrl;
            } catch {
                a.parentNode?.removeChild(a);
            }
        });
        return div.innerHTML;
    }
}

